import axios from 'axios'

export default {
  namespaced: true,
  state: {
    videos: [],
    loading: false
  },
  mutations: {
    loading(state, value) {
      state.loading = value
    },
    videos(state, value) {
      state.videos = value
    }
  },
  actions: {
    fetchLessonVideos({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('loading', true)
        axios.get('/videos')
          .then((response) => {
            commit('videos', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('loading', false)
          })
      })
    },
    getVideo({commit, state}, id) {
      return axios.get('/video/' + id)
        .then(({data}) => {
          return Promise.resolve(data)
        })

    }
  },
  getters: {
    videos: state => state.videos,
    loading: state => state.loading
  }
}
